// AboutCard
import React from 'react';
import Link from 'next/link';
import ROUTES from 'config/routes';
import { CreatorProfileType } from 'types/profile';
import { IncompleteTag } from '..';
import { DEFAULT_ABOUT_SKILLS_TEXT } from 'constants/profile';
import styles from './AboutCard.module.sass';

export interface AboutCardProps {
  about: string;
  profileType: CreatorProfileType;
  trackEditProfileClick: () => void;
}

const AboutCard: React.FC<AboutCardProps> = ({
  about,
  profileType,
  trackEditProfileClick,
}) => {
  return (
    <div className={styles.aboutCard}>
      {profileType === 'personal' && (
        <Link passHref href={ROUTES.AccountSettings.getPath()} legacyBehavior>
          <p
            onClick={trackEditProfileClick}
            id="about"
            className={styles.editButton}
          >
            Edit
          </p>
        </Link>
      )}
      <div className={styles.cardTitleRow}>
        <h5>About You</h5>
        {!about && profileType === 'personal' && <IncompleteTag />}
      </div>
      <p className={styles.aboutText}>
        {about || DEFAULT_ABOUT_SKILLS_TEXT['about']}
      </p>
    </div>
  );
};

export default AboutCard;
